<template lang="html">
  <div>
    <form v-on:submit.prevent="onSubmit" id="needs-validation" v-if="!formSubmittedSuccessfully && !errorAfterSubmission" novalidate>
      <p><span class="text-danger">*</span> = Champ requis</p>

      <div class="alert alert-danger" role="alert" v-if="formIsSubmitted && !formIsValid">
        Une/plusieurs erreur(s) est/sont présente(s) dans le formulaire; merci de la/les corriger.
      </div>

      <div class="form-row">
        <div class="form-group col-sm-6">
          <label for="contactInputFirstname">Prénom <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="contactInputFirstname" v-model="contact.firstName" required>
          <div class="invalid-feedback">
            Le prénom est requis
          </div>
        </div>
        <div class="form-group col-sm-6">
          <label for="contactInputName">Nom <span class="text-danger">*</span></label>
          <input class="form-control" id="contactInputName" v-model="contact.name" required>
          <div class="invalid-feedback">
            Le nom est requis
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-6">
          <label for="contactInputEmail">Adresse e-mail <span class="text-danger">*</span></label>
          <input type="email" class="form-control" id="contactInputEmail" v-model="contact.email" required>
          <div class="invalid-feedback">
            L'adresse e-mail est requise
          </div>
        </div>
        <div class="form-group col-sm-6">
          <label for="contactInputPhone">Numéro de téléphone <span class="text-danger">*</span></label>
          <input type="tel" class="form-control" id="contactInputPhone" v-model="contact.phone" required>
          <div class="invalid-feedback">
            Le numéro de téléphone est requis
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-6">
          <label for="contactInputFrom">Du <span class="text-danger">*</span></label>
          <input type="date" class="form-control" id="contactInputFrom" v-model="contact.from" required>
          <div class="invalid-feedback">
            La date de prise est requise
          </div>
        </div>
        <div class="form-group col-sm-6">
          <label for="contactInputTo">Jusqu'au <span class="text-danger">*</span></label>
          <input type="date" class="form-control" id="contactInputTo" v-model="contact.to" required>
          <div class="invalid-feedback">
            La date de retour est requise
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="contactInputAssociation">Nom de l'association/du collectif représenté</label>
        <input class="form-control" id="contactInputAssociation" v-model="contact.association">
      </div>
      <div class="form-group">
        <label for="contactInputDemand">Matériel désiré (selon la liste disponible) <span class="text-danger">*</span></label>
        <textarea class="form-control" id="contactInputDemand" rows="8" cols="80" v-model="contact.wanted" required></textarea>
        <div class="invalid-feedback">
          La liste du matériel désiré est requis
        </div>
      </div>
      <div class="form-group">
        <label for="contactInputWanted">Quel matériel auriez-vous désiré?</label>
        <textarea class="form-control" id="contactInputWanted" rows="8" cols="80" v-model="contact.demand"></textarea>
      </div>
      <div class="form-group">
        <label for="contactInputBiais">Par quel biais nous avez-vous connus?</label>
        <input class="form-control" id="contactInputBiais" v-model="contact.biais">
      </div>

      <div class="alert alert-danger" role="alert" v-if="formIsSubmitted && !formIsValid">
        Une/plusieurs erreur(s) est/sont présente(s) dans le formulaire; merci de la/les corriger.
      </div>

      <button type="submit" class="btn btn-primary">Envoyer</button>
    </form>

    <div class="alert alert-success" role="alert" v-if="formSubmittedSuccessfully">
      Merci de nous avoir transmis votre demande, un gestionnaire de notre équipe prendra rapidement contact avec vous.
    </div>

    <div class="alert alert-danger" role="alert" v-if="errorAfterSubmission">
      Une erreur s'est produite lors de la soumission du formulaire. Merci de réessayer ou de <a href="mailto:julien.grunhagel@lyoxa.ch" class="alert-link">contacter le support</a>.
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      formIsSubmitted: false,
      formIsValid: false,
      formSubmittedSuccessfully: false,
      errorAfterSubmission: false,
      contact: {
        firstName: '',
        name: '',
        email: '',
        phone: '',
        association: '',
        demand: '',
        wanted: '',
        from: '',
        to: ''
      }
    }
  },
  methods: {
    validateForm () {
      const form = document.getElementById('needs-validation')
      if (form.checkValidity() !== false) {
        this.formIsValid = true
        return true
      }
      form.classList.add('was-validated')
      return false
    },
    onSubmit () {
      this.formIsSubmitted = true
      if (this.validateForm()) {
        let apiURL = 'https://bp60k0083l.execute-api.eu-central-1.amazonaws.com/prod/bdmLyoxaForm'
        axios
          .post(apiURL, JSON.stringify(this.contact))
          .then(response => {
            this.formSubmittedSuccessfully = true
            this.errorAfterSubmission = false
          }, response => {
            this.formSubmittedSuccessfully = false
            this.errorAfterSubmission = true
          })
      }
    }
  }
}
</script>
